// src/components/Contact.tsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Contact.scss';
import { useTranslation } from 'react-i18next';

const Contact: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <Container id="contact" className={`contact-section ${className}`}>
      <Row className="justify-content-center">
        <Col lg={8} className="text-center">
          <h2 className="contact-title">{t('contact.title')}</h2>
          <p className="contact-description">{t('contact.description')}</p>
          
          <div className="contact-methods">
            <div className="contact-method-item">
              <span className="method-label">{t('contact.email')}</span>
              <a href={`mailto:${t('contact.contactInfo.emailAddress')}`} className="method-link">
                {t('contact.contactInfo.emailAddress')}
              </a>
            </div>
            <div className="contact-method-item">
              <span className="method-label">{t('contact.contactInfo.phone').split(':')[0]}</span>
              <a href={`tel:${t('contact.contactInfo.phoneNumber').replace(/\s/g, '')}`} className="method-link">
                {t('contact.contactInfo.phoneNumber')}
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
